<template>
  <div class="maximum-width">
    <h1 class="container text-white">
          About Us
    </h1>
    <div class="spacer" />
    <div class="special-bg repco-bg">
      <div class="container text-white text-outline">
        <section class="row">
          <div class="col-4">
            <img src="@/assets/icons/locationpin.png">
            <h4>
              Locally Owned And Operated
            </h4>
            <p>
              Conveniently located in Fyshwick, Canberra, we are open 6 DAYS A WEEK and offer flexible booking times.
            </p>
          </div>
          <div class="col-4">
            <img src="@/assets/icons/warranty.png">
            <h4>
              Nation Wide Warranty
            </h4>
            <p>
              With over 370 service centres across Australia, our full range of services are backed by our Repco Nationwide Warranty.
            </p>
          </div>
          <div class="col-4">
            <img src="@/assets/icons/onestop_icon.png">
            <h4>
              A 'One Stop' Service and Repair Shop
            </h4>
            <p>
              As well as a wide range of vehicle services,  we also offer a local pickup and delivery service as well as a courtesy loan vehicle.
            </p>
          </div>
        </section>
      </div>
    </div>
    <div class="spacer" />
    <div class="self-center-horizontally text-white" style="width:11.4em">
          <h2>
            Our Values:
          </h2>
          <h3>
            <ul class="text-left">
              <li> Honesty </li>
              <li> Reliability </li>
              <li> Customer Focus </li>
              <li> Value For Money </li>
            </ul>
          </h3>
        </div>
    <div class="spacer" />
    <div class="special-bg">
      <div class="spacer" />
      <div class="container text-white">
        <h2 class="text-outline"> Testimonials: </h2>
        <Slideshow :images="imageList" :isBG="false" :aspectRatio="'25%'" />
      </div>
      <div class="spacer" />
    </div>
  </div>
</template>
<script>
import Slideshow from '@/components/Slideshow'
import Images from '@/assets/json/testimonials-data.json'
export default {
  name: 'about',
  components: {
    Slideshow
  },
  data () {
    return {
      imageList: Images.images
    }
  }
}
</script>
<style lang="postcss" scoped>
  .special-bg {
    background-image:url("../assets/backgrounds/openroad.jpg");
  }
  .repco-bg {
    background-image:url(../assets/backgrounds/repco-shirt.jpg) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue